import React from "react";
import { motion } from "framer-motion";

const rooms = [
  {
    id: "living",
    title: "Living Room",
    image: "https://images.unsplash.com/photo-1758448755952-42b404bc6f39?w=600&q=80",
  },
  {
    id: "bedroom",
    title: "Bedroom",
    image: "https://images.unsplash.com/photo-1648634158203-199accfd7afc?w=600&q=80",
  },
  {
    id: "dining",
    title: "Dining Room",
    image: "https://images.unsplash.com/photo-1762117360877-2aa74c409f2b?w=600&q=80",
  },
  {
    id: "study",
    title: "Study Room",
    image: "https://images.unsplash.com/photo-1623351143485-b1d4937747f3?w=600&q=80",
  },
  {
    id: "pooja",
    title: "Pooja Room",
    image: "https://images.unsplash.com/photo-1616308913689-cb92c5bea67e?w=600&q=80",
  },
];

export const RoomsSection = () => {
  return (
    <section className="section bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-muted-foreground mb-4">
            Design Inspiration
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground">
            Room-wise Designs
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Unlock design inspiration and embark on a journey to transform your
            space into something extraordinary.
          </p>
        </motion.div>

        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4"
          data-testid="rooms-grid"
        >
          {rooms.map((room, index) => (
            <motion.div
              key={room.id}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              data-testid={`room-${room.id}`}
            >
              <div className="group relative aspect-square overflow-hidden rounded-xl border border-[hsl(var(--border))] cursor-pointer">
                <img
                  src={room.image}
                  alt={room.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.7)] via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <span className="inline-block px-4 py-2 rounded-full text-sm font-serif-alt font-semibold bg-white/10 text-white backdrop-blur-sm">
                    {room.title}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RoomsSection;
